import { useEffect, useState } from "react";
import App from "./App";
import WelcomeLoader from "./components/ui/WelcomeLoader";

export default function Root() {
  const [appReady, setAppReady] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (!appReady) return;
    const hideLoaderId = window.setTimeout(() => setShowLoader(false), 450);
    return () => window.clearTimeout(hideLoaderId);
  }, [appReady]);

  return (
    <>
      <div className={`app-shell ${appReady ? "app-shell--visible" : "app-shell--hidden"}`}>
        <App />
      </div>
      {showLoader && (
        <div className={`loader-shell ${appReady ? "loader-shell--fade" : ""}`}>
          <WelcomeLoader
            durationMs={5000}
            title="VaWeNa.AI"
            onComplete={() => setAppReady(true)}
          />
        </div>
      )}
    </>
  );
}
